export interface IDeliverySettings {
  orderAsLastTimeEnabled: boolean;
  freeDelivery: boolean;
  freeDeliveryGlobalLimit: number;
  freeDeliveryGlobalFrom: Date;
  freeDeliveryGlobalTo: Date;
  minimalPriceLimit: number;
}

export interface IDeliveryType {
  deliveryTypeId: number;
  priceLimit: number;
}

export const DELIVERY_DEFAULT_SETTINGS: IDeliverySettings = {
  orderAsLastTimeEnabled: false,
  freeDelivery: false,
  freeDeliveryGlobalLimit: 0,
  freeDeliveryGlobalFrom: new Date(),
  freeDeliveryGlobalTo: new Date(),
  minimalPriceLimit: 0,
};
